export const SET_SIMULATION_LEVEL = 'SET_SIMULATION_LEVEL',
  TOGGLE_NOTEBOOK_COLLAPSE = 'TOGGLE_NOTEBOOK_COLLAPSE',
  SET_NOTEBOOK_SECTION = 'SET_NOTEBOOK_SECTION',
  OEQ_RESPONSE_CHANGE = 'OEQ_RESPONSE_CHANGE',
  OEQ_SUBMIT_ANSWER = 'OEQ_SUBMIT_ANSWER',
  NEQ_INPUT_CHANGE = 'NEQ_INPUT_CHANGE',
  NEQ_SUBMIT_ANSWER = 'NEQ_SUBMIT_ANSWER',
  DDQ_DROPDOWN_CHANGE = 'DDQ_DROPDOWN_CHANGE',
  DDQ_SUBMIT_ANSWER = 'DDQ_SUBMIT_ANSWER',
  DNDQ_SELECT_SEQUENCE = 'DNDQ_SELECT_SEQUENCE',
  DNDQ_SUBMIT_ANSWER = 'DNDQ_SUBMIT_ANSWER',
  GROUPED_DNDQ_SELECT_SEQUENCE = 'GROUPED_DNDQ_SELECT_SEQUENCE',
  GROUPED_DNDQ_SUBMIT_ANSWER = 'GROUPED_DNDQ_SUBMIT_ANSWER',
  MSCQ_SELECT_OPTION = 'MSCQ_SELECT_OPTION',
  MSCQ_SUBMIT_ANSWER = 'MSCQ_SUBMIT_ANSWER',
  SELECT_QUESTION_OPTION = 'SELECT_QUESTION_OPTION',
  SUBMIT_QUESTION_ANSWER = 'SUBMIT_QUESTION_ANSWER',
  SELECT_REAGENT_OPTION = 'SELECT_REAGENT_OPTION',
  SUBMIT_REAGENT_ANSWER = 'SUBMIT_REAGENT_ANSWER',
  SLIDE_ONE_DRAG_DROP = 'SLIDE_ONE_DRAG_DROP',
  SLIDE_ONE_REMOVE_DROP = 'SLIDE_ONE_REMOVE_DROP',
  SLIDE_ONE_SET_AS_NEXT_STEP = 'SLIDE_ONE_SET_AS_NEXT_STEP',
  SET_NEW_CURRENT_PROTOCOL_SLIDE = 'SET_NEW_CURRENT_PROTOCOL_SLIDE',
  SLIDE_TWO_DRAG_DROP = 'SLIDE_TWO_DRAG_DROP',
  SLIDE_TWO_SET_AS_NEXT_STEP = 'SLIDE_TWO_SET_AS_NEXT_STEP',
  SLIDE_TWO_REMOVE_STEP = 'SLIDE_TWO_REMOVE_STEP',
  SLIDE_TWO_APPLY_HINT = 'SLIDE_TWO_APPLY_HINT',
  SLIDE_TWO_SELECT_PATH = 'SLIDE_TWO_SELECT_PATH',
  SLIDE_THREE_DRAG_DROP = 'SLIDE_THREE_DRAG_DROP',
  SLIDE_THREE_REMOVE_DROP = 'SLIDE_THREE_REMOVE_DROP',
  SLIDE_THREE_SET_AS_NEXT_STEP = 'SLIDE_THREE_SET_AS_NEXT_STEP',
  SLIDE_THREE_APPLY_HINT = 'SLIDE_THREE_APPLY_HINT',
  ON_GEL_UPDATE = 'ON_GEL_UPDATE',
  ON_GEL_SELECT = 'ON_GEL_SELECT',
  ON_SUBMIT = 'ON_SUBMIT',
  ON_RESET = 'ON_RESET',
  CLOSE_FEEDBACK = 'CLOSE_FEEDBACK',
  ON_DROP_DOWN_SUBMIT = 'ON_DROP_DOWN_SUBMIT',
  ON_DROP_DOWN_RESET = 'ON_DROP_DOWN_RESET',
  CLOSE_DROP_DOWN_FEEDBACK = 'CLOSE_DROP_DOWN_FEEDBACK',
  ON_DROP_DOWN_UPDATE = 'ON_DROP_DOWN_UPDATE',
  ON_DROP_DOWN_SELECT = 'ON_DROP_DOWN_SELECT',

  // HEAT BLOCK 
  TOGGLE_HEATBLOCK_MODAL_HB = 'TOGGLE_HEATBLOCK_MODAL_HB',
  UPDATE_TEMPERATURE_HB = 'UPDATE_TEMPERATURE_HB',
  TUBE_DROP_HB = 'TUBE_DROP_HB',
  CHECK_BALANCE_HB = 'CHECK_BALANCE_HB',
  TEMPREATURE_BALANCE_HB = 'TEMPREATURE_BALANCE_HB',
  TOOLTIP_DISPLAY_HB = 'TOOLTIP_DISPLAY_HB',
  TOOLTIP_REMOVE_HB = 'TOOLTIP_REMOVE_HB',
  TUBE_TOOLTIP_DISPLAY_HB = 'TUBE_TOOLTIP_DISPLAY_HB',
  TUBE_TOOLTIP_REMOVE_HB = 'TUBE_TOOLTIP_REMOVE_HB',
  REMOVE_TUBE_FROM_HEATBLOCK_HB = 'REMOVE_TUBE_FROM_HEATBLOCK_HB',
  SET_HEATING_HB = 'SET_HEATING_HB',

    // power supply action types
    TOGGLE_MODAL_OPEN= "TOGGLE_MODAL_OPEN_POWER_SUPPLY",
    TOGGLE_POWER= "TOGGLE_POWER_POWER_SUPPLY",
    SET_TIMER= "SET_TIMER_POWER_SUPPLY",
    SET_VOLTAGE= "SET_VOLTAGE_POWER_SUPPLY",
    SET_CURRENT= "SET_CURRENT_POWER_SUPPLY",
    ON_START= "ON_START_POWER_SUPPLY",
    ON_STOP= "ON_STOP_POWER_SUPPLY",
    ANIMATION_PLAYBACK_COMPLETE= "ANIMATION_PLAYBACK_COMPLETE_POWER_SUPPLY",
    ON_DROP_WIRE= "ON_DROP_WIRE_POWER_SUPPLY",
  
    // New microcentrifuge action types
    TOGGGLE_LID_MC = 'TOGGGLE_LID_MC',
    OPEN_MODAL_MC = 'OPEN_MODAL_MC',
    CLOSE_MODAL_MC = 'CLOSE_MODAL_MC',
    SET_MODAL_VIEW_MC = 'SET_MODAL_VIEW_MC',
    SET_RPM_MC = 'SET_RPM_MC',
    SET_TIMER_MC = 'SET_TIMER_MC',
    ON_DROP_SLOT_MC = 'ON_DROP_SLOT_MC',
    ON_RUN_CENTRIFUGE_MC = 'ON_RUN_CENTRIFUGE_MC',
    ON_STOP_CENTRIFUGE_MC = 'ON_STOP_CENTRIFUGE_MC',
    ANIMATION_PLAYBACK_COMPLETE_MC = 'ANIMATION_PLAYBACK_COMPLETE_MC',
    ON_DROP_CENTRIFUGE_MC = 'ON_DROP_CENTRIFUGE_MC',
    REMOVE_SLOT_ITEMS_MC = 'REMOVE_SLOT_ITEMS_MC';